import { useQuery, useQueryClient } from 'react-query';
import { User } from '../../lib/interfaces/User';
import { getUserMe } from '../../api/apis';
import reactQueryKeys from '../reactQueryKeys';

const useUserMeQuery = (options = {}) => {
	const queryClient = useQueryClient();
	return useQuery<User | null, Error>(
		[reactQueryKeys.userMe],
		() => getUserMe(),
		{
			onError: (error) => {
				console.error('fetch error >>> ', error);
				queryClient.setQueryData(reactQueryKeys.userMe, null);
			},
			...options,
		},
	);
};

export default useUserMeQuery;
